import {
  cancelAccessibilityRequest
} from "./chunk-POY332AO.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/accessibility/cancelRequest.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useCancelAccessibilityRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelAccessibilityRequest,
    onSuccess: (data) => {
      queryClient.setQueryData(["accessibilityRequests"], __spreadValues({}, data));
    }
  });
};

export {
  useCancelAccessibilityRequest
};
//# sourceMappingURL=chunk-27EUUSDD.mjs.map